import { Component, Input, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { TableModule } from 'primeng/table';
import { TabViewModule } from "primeng/tabview";
import { DonorCardService } from "../../services/donor-card.service";
import { DonationCardService } from "../../services/donation-card.service";
import { MainModel } from "../../../global/model/MainModel";
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from "@angular/forms";
import { ChartModule } from 'primeng/chart';
import { DonorFundTotalsGridComponent } from "../../shared-components/donor-fund-totals-grid/donor-fund-totals-grid.component";
import { SidebarModule } from 'primeng/sidebar';
import { DonorAddComponent } from "../donor-add/donor-add.component";
import { DonorFormModel } from "../../models/DonorModel";
import { LoadingSpinnerComponent } from "../../../global/component/loading-spinner/loading-spinner.component";
import { DialogModule } from "primeng/dialog";
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AutocompleteService } from '../../services/autocomplete.service';
import { DonationGeneralTabComponent } from "./donation-general-tab/donation-general-tab.component";
import { DonationContactTabComponent } from "./donation-contact-tab/donation-contact-tab.component";
import { DonationFecComplianceTabComponent } from "./donation-fec-compliance-tab/donation-fec-compliance-tab.component";
import { DonationFlagsTabComponent } from "./donation-flags-tab/donation-flags-tab.component";
import { DonationFundraisersTabComponent } from "./donation-fundraisers-tab/donation-fundraisers-tab.component";
import { DonationLettersTabComponent } from "./donation-letters-tab/donation-letters-tab.component";
import { DonationNotesTabComponent } from "./donation-notes-tab/donation-notes-tab.component";
import { DonationParentChildTabComponent } from "./donation-parent-child-tab/donation-parent-child-tab.component";
import { DonorInfoTabComponent } from "./donor-info-tab/donor-info-tab.component";
import { CurrentCycleDonationsComponent } from '../../shared-components/current-cycle-donations/current-cycle-donations.component';
import { DonorLifetimeHistoryComponent } from "../../shared-components/donor-lifetime-history/donor-lifetime-history.component";
import { DonationCardDonationsGridRow, DonationCardGeneralInfoVM, FECComplianceUpdateViewModel } from "../../models/DonationCardModels";
import { DonationTransactionHistoryComponent } from "./donation-transaction-history/donation-transaction-history.component";
import { DonationHeaderComponent } from './donation-header/donation-header.component';
import { MessageService } from 'primeng/api';
import { DonorCardComponent } from "../donor-card/donor-card.component";
import Campaign from "../../../global/model/Campaign";
import { MessageModule } from "primeng/message";
import { CampaignPageEnum, FeatureAccess } from "../../../global/model/CampaignFeature";

@Component({
  selector: 'app-donation-card',
  templateUrl: './donation-card.component.html',
  styleUrls: ['./donation-card.component.scss'],
  standalone: true,
  imports: [
    FormsModule, 
    TabViewModule, 
    CardModule, 
    ButtonModule,
    CommonModule, 
    TableModule, 
    CheckboxModule, 
    GenericButtonComponent, 
    CalendarModule, 
    DropdownModule, 
    InputTextareaModule, 
    InputSwitchModule, 
    ChartModule, 
    ToastModule, 
    DonorFundTotalsGridComponent, 
    SidebarModule, 
    DonorAddComponent,
    LoadingSpinnerComponent, 
    DialogModule, 
    AutoCompleteModule,
    DonationGeneralTabComponent,
    DonationContactTabComponent,
    DonationFecComplianceTabComponent,
    DonationFundraisersTabComponent,
    DonationParentChildTabComponent,
    DonorInfoTabComponent,
    DonationFlagsTabComponent,
    DonationNotesTabComponent,
    DonationLettersTabComponent,
    CurrentCycleDonationsComponent,
    DonorLifetimeHistoryComponent,
    DonationTransactionHistoryComponent,
    DonationHeaderComponent,
    DonorCardComponent,
    MessageModule
  ],
  providers: [
    DonorCardService,
    DonationCardService,
    AutocompleteService,
    MessageService,
    CurrencyPipe
  ]
})
export class DonationCardComponent {
  @ViewChild(DonationGeneralTabComponent) generalTabComponent!: DonationGeneralTabComponent;
  @ViewChild(DonationHeaderComponent) headerComponent!: DonationHeaderComponent;
  @ViewChild(DonationFecComplianceTabComponent) fecComplianceTab!: DonationFecComplianceTabComponent;
  @ViewChild(DonationParentChildTabComponent) parentChildTab!: DonationParentChildTabComponent;
  @ViewChild(DonationTransactionHistoryComponent) transactionHistoryComponent!: DonationTransactionHistoryComponent;

  donorId: string;
  donationId!: number;
  splitId!: number;
  campaignId!: number;
  isDeleteModalVisible: boolean = false;
  activeTab: string = 'General';
  fecInfo?: FECComplianceUpdateViewModel;
  donationAmount: number = 0;

  @Input() isReadOnlyMode: boolean = false;
  pageAccess: FeatureAccess = 2; // Default to Full Access

  constructor(
    private route: ActivatedRoute,
    private mainModel: MainModel,
    private donorCardService: DonorCardService,
    private donationCardService: DonationCardService,
    private messageService: MessageService,
    private currencyPipe: CurrencyPipe,
    private router: Router
  ) {
    this.donorId = this.route.snapshot.paramMap.get('id') ?? '';
  }
  donationLetters = [];
  generalInfo?: DonationCardGeneralInfoVM;
  primaryAddress: any;
  phoneNumber: any;
  emailAddress: any;
  expandedRows = {};
  donorLetters = [];
  donorCallsheetsLog = [];
  donorNotes = [];
  donorFlags = [];
  donorCurrentCycleDonations: any;
  donorCurrentCycleDonationsChartData: any;
  donorCurrentCycleDonationsChartOptions: any;
  donationTransactions: DonationCardDonationsGridRow[] = [];
  fundcodesHistory: any = [];


  // dialog modals
  showDonationLetterDialog: boolean = false;
  showThankYouNoteDialog: boolean = false;
  showCustomNoteDialog: boolean = false;
  showComplianceActionDialog: boolean = false;

  tabIndex = 0;
  donorToEdit: DonorFormModel | null = null;
  editStep = 0;
  @Input({ required: true }) isDockable: boolean = true;
  isDonationEditSidebarVisible: boolean = false;
  isDonorEditSidebarVisible: boolean = false;
  isDonorEditDataLoading: boolean = false;
  @Input() isModalPopup: boolean = false;
  @Input() fromSearchDonorID: any;

  isHeaderDataModalVisible: boolean = false;

  // Mock data for headerData
  headerData: any = {
    donationAmount: "$125.00",
    donationDate: "11/23/2024",
    donationID: "18368724",
    donorFirstName: "Barnaby",
    donorLastName: "Smith",
    campaignName: "Texans for Hurd",
    fundCode: "Demo-P2016"
  };

  isDonorCardModalVisible: boolean = false;
  selectedDonorId: number | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fromSearchDonorID']) {
      this.donorId = this.fromSearchDonorID ? this.fromSearchDonorID : this.route.snapshot.paramMap.get('id') ?? '';
    }
  }

  handleGeneralInfoUpdate(generalInfo: DonationCardGeneralInfoVM): void {
    this.generalInfo = generalInfo;
  }

  handleFecInfoRetrieved(fecInfo: FECComplianceUpdateViewModel) {
    this.fecInfo = fecInfo;
  }

  switchTab(selectedTab: any) {
    this.editStep = -1;

    switch (selectedTab.index) {
      case 0: { // General
        this.activeTab = 'General';
        this.editStep = 0;
        break;
      }
      case 1: { // Donor Info
        this.activeTab = 'Donor Info';
        this.editStep = 0;
        break;
      }
      case 2: { // Contact
        this.activeTab = 'Contact';
        this.editStep = 0;
        break;
      }
      case 3: { // FEC Compliance
        this.activeTab = 'FEC Compliance';
        this.editStep = 0;
        break;
      }
      case 4: { // Parent/Child
        this.activeTab = 'Parent/Child';
        this.editStep = 0;
        break;
      }
      case 5: { // Fundraisers
        this.activeTab = 'Fundraisers';
        break;
      }
      case 6: { // Donation Letters
        this.activeTab = 'Donation Letters';
        break;
      }
      case 7: { // Notes
        this.activeTab = 'Notes';
        break;
      }
      case 8: { // Donation Flags
        this.activeTab = 'Donation Flags';
        break;
      }
      default: {
        this.activeTab = '';
        break;
      }
    }
  }

  handleEditDonation() {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Editing is disabled.'
      });
      return;
    }
    if (this.activeTab === 'General' && this.generalTabComponent) {
      this.generalTabComponent.onEditClick();
    } else if (this.activeTab === 'FEC Compliance' && this.fecComplianceTab) {
      this.fecComplianceTab.onEditClick(); 
    } else if (this.activeTab === 'Parent/Child' && this.parentChildTab) {
      this.parentChildTab.onEditClick();
    } else {
      this.editDonor();
    }
  }

  handleDonationHeaderUpdate(updatedData: { donationDate: string, donationAmount: number, fundCode: string }) {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Editing is disabled.'
      });
      return;
    }
    if (this.headerComponent) {
      this.headerComponent.loadHeaderData();
    }
  }

  handleUpdateDonationGeneralInfo(): void {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Editing is disabled.'
      });
      return;
    }
    if (this.generalTabComponent) {
      this.generalTabComponent.loadGeneralInfo();
    }
  }

  ngOnInit(): void {
    this.isReadOnlyMode = false;
    const snapshotParams = this.route.snapshot.queryParamMap;
    const donationId = snapshotParams.get('donationId');
    const splitId = snapshotParams.get('splitId');
    if (donationId) {
      this.donationId = +donationId;
    }
    if (splitId) {
      this.splitId = +splitId;
    }

    this.route.queryParamMap.subscribe(params => {
      const donationId = params.get('donationId');
      const splitId = params.get('splitId');
      if (donationId) {
        this.donationId = +donationId;
      }
      if (splitId) {
        this.splitId = +splitId;
      }
    });

    // Fetch the selected campaign if it's null
    const selectedCampaignId = this.mainModel.userSelectedCampaignId;
    if (!selectedCampaignId) {
      this.mainModel.fetchSelectedCampaign().subscribe({
        next: (campaign: Campaign) => {
          this.campaignId = campaign.campaignId;
          this.mainModel.fetchAndSetUserCampaignProductsFeaturesPages(campaign.campaignId).subscribe({
            next: (features) => {
              this.pageAccess = this.mainModel.userCampaignPageAccess(CampaignPageEnum.DonationCard);
              this.isReadOnlyMode = (this.pageAccess === FeatureAccess.ReadOnly);
            },
            error: (err) => {
              console.error('Failed to fetch user campaign products features pages:', err);
            }
          });
        },
        error: (err) => {
          console.error('Failed to fetch selected campaign:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch the selected campaign. Please try again later.',
            life: 5000,
          });
        },
      });
    } else {
      this.campaignId = selectedCampaignId;
      this.pageAccess = this.mainModel.userCampaignPageAccess(CampaignPageEnum.DonationCard);
      this.isReadOnlyMode = (this.pageAccess === FeatureAccess.ReadOnly);
    }

    if (isNaN(this.campaignId)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Campaign ID',
        detail: 'The selected campaign ID is invalid. Please select a valid campaign.',
        life: 5000,
      });
      return;
    }

    
  }

  getRemainingFlag(remaining: string) {
    if (parseFloat(remaining) < 0) {
      return 'danger';
    }
    return null;
  }

  onFundcodesHistoryLoaded(fundcodesHistory: any)
  {
    this.fundcodesHistory = fundcodesHistory;
  }

  editDonor() {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Editing is disabled.'
      });
      return;
    }
    if (this.activeTab === 'Donor Info' || this.activeTab === 'Contact') {
      this.isDonorEditSidebarVisible = true;
      this.isDonorEditDataLoading = true;

      this.editStep = this.activeTab === 'Donor Info' ? 0 : 1;

      this.loadDonorDataForEdit();
    } else {
      console.warn('Edit Donor is only available on Donor Info and Contact tabs.');
    }
  }

  loadDonorDataForEdit(): void {    
    if (this.isReadOnlyMode) {
      return;
    }
    if (this.donorId !== '') {
      this.donorCardService.getDonorForEdit(parseInt(this.donorId)).subscribe({
        next: data => {
          console.debug(data);
          this.isDonorEditDataLoading = false;
          this.donorToEdit = data;
        },
        error: err => {
          console.error('Unable to retrieve donor data for editing. Please try again later.', err);
        },
      });
    }
  }

  closeModal() {
    this.isDonorEditSidebarVisible = false;
  }

  openDonorCardModal(donorId: number): void {
    this.selectedDonorId = donorId;
    this.isDonorCardModalVisible = true;
  }

  onDonationAmountChange(amount: any): void {
    const numericAmount = parseFloat(amount.replace('$', '').trim());
    this.donationAmount = isNaN(numericAmount) ? 0 : numericAmount;
   // this.transactionHistoryComponent.originalDonationAmount = numericAmount;
  }

  closeDonorCardModal(): void {
    this.isDonorCardModalVisible = false;
    this.selectedDonorId = null;
  }

  showDeleteModal(): void {
    this.isDeleteModalVisible = true;
  }

  onCancelDelete(): void {
    this.isDeleteModalVisible = false;
  }

  onConfirmDelete(): void {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Deletion is disabled.'
      });
      this.isDeleteModalVisible = false;
      return;
    }
    this.donationCardService.deleteDonation(this.donationId).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Donation deleted successfully.',
        });
        this.isDeleteModalVisible = false;
        this.router.navigate(['vortex/donations/donation-search']);
      },
      error: (err: any) => {
        console.error('Error deleting donation:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the donation. Please try again.',
        });
        this.isDeleteModalVisible = false;
      },
    });
  }

  handleDeleteDonation(): void {
    if (this.isReadOnlyMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Read Only',
        detail: 'This page is in read-only mode. Deletion is disabled.'
      });
      return;
    }
    this.showDeleteModal();
  }

  scrollToTransactionHistory(): void {
    const transactionHistoryElement = document.getElementById('donation-transaction-history');
    if (transactionHistoryElement) {
      transactionHistoryElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
